module.exports = __webpack_public_path__ + "img/gl.d81ba18a.png";